import styles from './styles.module.css'
import ZipCodeTable from '../zip-code-table/ZipCodeTable'
import { LocationForm, ILocationFormProps } from '../location-form/LocationForm'
import { ITabulationAreasProps } from './LocationModal'
import SurveyUrlManager from '../survey-url-manager/SurveyUrlManager'
import CellsManager from '../cells-manager/CellsManager'

export interface ILocationCreateProps {
  locationFormInfo: ILocationFormProps
  tabulationAreasProps: ITabulationAreasProps
  refetch?: Function
}

export default function LocationCreate(props: ILocationCreateProps) {
  const { locationFormInfo: locationFormDataProps, tabulationAreasProps } =
    props
  const { locationFormInfo, setLocationFormInfo } = locationFormDataProps
  const { objectId: locationObjectId } = locationFormInfo

  //temp logic to disable table functions when creating a new location as api response on create location is broken, so cant create zips directly after creating
  const isEditOrCreate = locationObjectId ? false : true

  return (
    <div className={styles.mainContainer}>
      <LocationForm {...locationFormDataProps} />
      <div className={styles.tableContainer}>
        <ZipCodeTable
          tabulationAreasProps={tabulationAreasProps}
          isEditOrCreate={isEditOrCreate}
          locationId={locationObjectId}
          refetch={props.refetch}
        />
        <CellsManager
          locationFormInfo={locationFormInfo}
          setLocationFormInfo={setLocationFormInfo}
        />
        <SurveyUrlManager
          locationFormInfo={locationFormInfo}
          setLocationFormInfo={setLocationFormInfo}
        />
      </div>
    </div>
  )
}
